import "./App.css"
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import AboutUs from "./pages/AboutUs/AboutUs";
import Home from "./pages/Home/Home";
import OurPromise from "./pages/OurPromise/OurPromise";
import Navbar from "./components/Navbar/Navbar";
import Solutions from "./pages/Solutions/Solutions";
import OurEdge from "./pages/OurEdge/OurEdge";
import OurBrands from "./pages/OurBrands/OurBrands";
import ContactUs from "./pages/ContactUs/ContactUs";


function App() {
  return (
    <Router>
      <div className="App">
      <Navbar/>
      <Routes>
        <Route exact path="/" element={<Home/>} />
        <Route exact path="/aboutus" element={<AboutUs/>} />
        <Route exact path="/ourpromise" element={<OurPromise/>} />
        <Route exact path="/solutions" element={<Solutions/>} />
        <Route exact path="/ouredge" element={<OurEdge/>} />
        <Route exact path="/ourbrands" element={<OurBrands/>} />
        <Route exact path="/contactus" element={<ContactUs/>} />
      </Routes>
      </div>
    </Router>
  );
}

export default App;
